import NetworkSettings from "../NetworkSettings";
import { fallback, http } from 'viem';
import { resolveAdapterChain } from "./resolveChain";
const chainsToFilter = [70700, 70701];
export function getEvmChainsConfig(networks, networkAdapter) {
    const isChain = (c) => c != undefined;
    const settingsChains = networks
        .slice()
        .sort((a, b) => (NetworkSettings.KnownSettings[networkAdapter.getId(a)]?.ChainOrder || Number(networkAdapter.getChainId(a))) - (NetworkSettings.KnownSettings[networkAdapter.getId(b)]?.ChainOrder || Number(networkAdapter.getChainId(b))))
        .filter(network => networkAdapter.isEvmNetwork(network)
        && networkAdapter.getRpcUrls(network).length > 0
        && networkAdapter.getNativeCurrency(network)
        && networkAdapter.getChainId(network) && !chainsToFilter.includes(Number(networkAdapter.getChainId(network))))
        .map(network => resolveAdapterChain(network, networkAdapter))
        .filter(isChain);
    const transports = {};
    settingsChains.forEach(chain => {
        const urls = chain.rpcUrls.default.http;
        transports[chain.id] = urls.length > 0 ? fallback(urls.map(url => http(url))) : http();
    });
    return {
        chains: settingsChains,
        transports,
    };
}
